import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { createPortal } from 'react-dom';
import { logout } from '../../store/actions/auth';
import { ReactComponent as LogOutIcon } from '../../assets/icons/logOut.svg';
import { ReactComponent as SettingsIcon } from '../../assets/icons/setting.svg';
import { ReactComponent as MessageIcon } from '../../assets/icons/rightChat.svg';
import { ReactComponent as ChatIcon } from '../../assets/icons/chat.svg';
import { ReactComponent as NotifyIcon } from '../../assets/icons/bell.svg';
import RightBar from '../RightBar/RightBar';
import classes from './header.module.scss';
import { readMessage, socketInit } from '../../store/actions/rightBar';
import avatarImg from '../../assets/icons/avatar.png';
import { getUnseenCountRequest, healthPlanSocketInit } from '../../store/actions/chat';
import AccountHelpers from '../../utils/accountHelpers';
import Loader from '../_common/Loader/Loader';

const Header = ({ account }) => {
  const isPatient = AccountHelpers.isInOneOfRoles(['Patient']);
  const adminToken = AccountHelpers.getAdminToken();
  const adminRefreshToken = AccountHelpers.getAdminRefreshToken();
  const token = AccountHelpers.getToken();

  const dispatch = useDispatch();
  const { newMessagesCount, notificationUnreadCount } = useSelector((store) => store.rightBar);
  const unSeenCount = useSelector((store) => store.chat.unSeenCount);

  const [isMenuOpen, menuOpeningToggle] = useState(false);
  const [currentTab, setCurrentTab] = useState(isPatient ? 'notifications' : 'chat');
  const [isChatOpen, chatOpeningToggle] = useState(false);
  const [loading, setLoading] = useState(false);

  const closeMenu = (ev) => {
    if (!ev.target.closest('[data-id="menu_container"]')) {
      menuOpeningToggle(false);
    }
  };

  const closeMenuAfterScroll = () => {
    if (window.pageYOffset > 70) {
      menuOpeningToggle(false);
    }
  };

  useEffect(() => {
    window.addEventListener('click', closeMenu, true);
    window.addEventListener('scroll', closeMenuAfterScroll, true);

    return () => {
      window.removeEventListener('click', closeMenu);
      window.removeEventListener('scroll', closeMenuAfterScroll, true);
    };
  }, []);

  useEffect(() => {
    if (token) {
      dispatch(socketInit(token));
      // dispatch(healthPlanSocketInit(token));
      // dispatch(getUnseenCountRequest());
    }
  }, []);

  const showRightBar = (tab) => {
    if (currentTab === tab || !isChatOpen) {
      chatOpeningToggle((prev) => !prev);
    }

    setCurrentTab(tab);
  };

  const openMenu = () => {
    menuOpeningToggle((prev) => !prev);
    chatOpeningToggle(false);
  };

  const openChat = () => {
    showRightBar('chat');

    if (newMessagesCount) dispatch(readMessage());
  };

  const goBack = async () => {
    setLoading(true);

    AccountHelpers.getAdminData();

    AccountHelpers.removeLocalStorageToAdmin();

    window.location.href = '/scripts';
  };

  return (
    loading
      ? createPortal(
        <div
          className={classes.loader_container}
        >
          <Loader />
        </div>,
        document.getElementById('root') || document.body,
      )
      : (
        <>
          <header id="header" className={classes.header_wrapper}>
            <div className={classes.logo_wrapper}>
              <NavLink to="/">
                <div style={{
                  backgroundImage: 'url(/favicon-32x32.png)',
                  width: 32,
                  height: 32,
                  marginRight: 10,
                }}
                />

                SortPak
              </NavLink>

              {adminToken && adminRefreshToken && (
              <div
                role="button"
                tabIndex="0"
                className={classes.go_back}
                onClick={goBack}
              >
                <LogOutIcon className={classes.menu_icon} />

                Go back
              </div>
              )}
            </div>

            <div className={classes.right_block_wrapper}>
              {/* <NavLink to="/chat" className={classes.chat_button}> */}
              {/*  <ChatIcon alt="chat" className={classes.chat_icon} /> */}

              {/*  <p className={classes.chat_text}>Internal Chat</p> */}

              {/*  {!!unSeenCount && <div className={classes.chat_message_count}>{unSeenCount}</div>} */}
              {/* </NavLink> */}

              <div className={classes.right_bar_controller}>
                {!isPatient
              && (
                <button
                  type="button"
                  onClick={openChat}
                  className={classes.message_button}
                >
                  <MessageIcon alt="message" />

                  <p className={classes.message_text}>Chat with patients</p>

                  {!!newMessagesCount && currentTab !== 'chat'
                  && <div className={classes.count}>{newMessagesCount}</div>}
                </button>
              )}

                <button type="button" onClick={() => showRightBar('notifications')}>
                  <NotifyIcon />

                  {!!notificationUnreadCount
                && (
                  <div className={`${classes.count} ${classes.notification_count}`}>{notificationUnreadCount}</div>
                )}
                </button>
              </div>

              <div
                role="button"
                tabIndex="0"
                data-id="menu_container"
                className={`${classes.account_menu_wrapper} ${isMenuOpen ? classes.menu_open : ''}`}
                onClick={openMenu}
              >
                <div className={classes.user_name_wrapper}>
                  <img
                    src={account.link}
                    className={classes.user_image}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = avatarImg;
                    }}
                    alt="link"
                  />

                  <div className={classes.user_name}>
                    {account.name}
                  </div>

                  <div className={classes.arrow} />
                </div>

                <div className={classes.menu}>

                  <NavLink to={`/team/${AccountHelpers.getUser().id}/profile`} className={classes.menu_item}>
                    <SettingsIcon className={classes.menu_icon} />
                    Settings
                  </NavLink>

                  <div
                    role="button"
                    tabIndex="0"
                    className={classes.menu_item}
                    onClick={logout}
                  >
                    <LogOutIcon className={classes.menu_icon} />
                    Log Out
                  </div>
                </div>
              </div>
            </div>
          </header>

          <RightBar
            show={isChatOpen}
            currentTab={currentTab || 'chat'}
            setCurrentTab={setCurrentTab}
          />
        </>
      )
  );
};

Header.propTypes = {
  account: PropTypes.object.isRequired,
};

export default Header;
